import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';


// Layouts
import UserLayout from './components/layouts/userlayout';

// User Components
import Home from './components/home/home';
import Purpose from './components/purpose/purpose';
import Vision from './components/vision/vision';
import Ethics from './components/ethics/ethics';
import Register from './components/register/register';
import Board from './components/board/board';
import Ourteam from './components/ourteam/ourteam';
import Performance from './components/performance/performance';
import EthicsMember from './components/ethics/ethicsmember';
import EthicsBoard from './components/ethics/ethicsboard';
import EthicsOfficer from './components/ethics/ethicsofficer';
import Depositservice from './components/depositservice/depositservice';
import Shareservice from './components/shareservice/shareservice';
import Manual from './components/manual/manual';
import Giftvoucher from './components/giftvoucher/giftvoucher';
import Bank from './components/bank/bank';
import Linktoother from './components/linktoother/linktoother';
import Regulation from './components/regulation/regulation';
import Policy from './components/policy/policy';
import Enactment from './components/enactment/enactment';
import Yearlyreport from './components/yearlyreport/yearlyreport';
import Calendar from './components/calendar/calendar';
import Calculatedividend from './components/calculatedividend/calculatedividend';
import Withdrawatm from './components/withdrawatm/withdrawatm';
import Contactus from './components/contactus/contactus';
import PersonalLoan from './components/personalloanads/personalloan';
import PersonalLoanATM from './components/personalloanads/personalloanatm';
import PersonalLoanforTOP from './components/personalloanads/personalloanfortop';
import PersonalLoanformerEmployee from './components/personalloanads/personalloanformeremployee';
import PersonalLoanforAutomobileTOP from './components/personalloanads/personalloanforautomobiletop';
import PersonalLoanforHome from './components/personalloanads/personalloanforhome';
import PersonalLoanforHomePlus from './components/personalloanads/personalloanforhomeplus';
import PersonalLoanforRenovate from './components/personalloanads/personalloanforrenovate';
import PersonalLoanforHomeCondoRedeem from './components/personalloanads/personalloanforhomecondoredeem';
import PersonalLoanforRedeem from './components/personalloanads/personalloanforredeem';
import PersonalLoanforHomeVersatile from './components/personalloanads/personalloanforhomeversatile';
import Personalloanads from './components/personalloanads/personalloanads';
import Anoucement from './components/anoucement/anoucement';
import Downloadform from './components/downloadform/downloadform';
import Activity from './components/activity/activity';
import Advertise from './components/advertise/advertise';
import ActivityDetail from './components/activity/activitydetail';
import AdvertiseDetail from './components/advertise/advertisedetail';
import PersonalLoanDetail from './components/personalloanads/personalloandetail';

export default class App extends Component {
  render() {
    return (
      <div>
        <Router basename="/WebsiteSavingsCoop" > {/* WebsiteSavingsCoopQas WebsiteSavingsCoop */}
          <Routes>
            {/* basename="/coopwebsite" */}
            {/* Redirect from root (/) to /home */}
            <Route path="/" element={<Navigate to="/home" replace />} />

            {/* User Routes */}
            <Route path="/home" element={<UserLayout />}>
              <Route index element={<Home />} />
            </Route>
            <Route path="/purpose" element={<UserLayout />}>
              <Route index element={<Purpose />} />
            </Route>
            <Route path="/vision" element={<UserLayout />}>
              <Route index element={<Vision />} />
            </Route>
            <Route path="/ethics" element={<UserLayout />}>
              <Route index element={<Ethics />} />
            </Route>
            <Route path="/register" element={<UserLayout />}>
              <Route index element={<Register />} />
            </Route>
            <Route path="/board" element={<UserLayout />}>
              <Route index element={<Board />} />
            </Route>
            <Route path="/ourteam" element={<UserLayout />}>
              <Route index element={<Ourteam />} />
            </Route>
            <Route path="/performance" element={<UserLayout />}>
              <Route index element={<Performance />} />
            </Route>
            <Route path="/ethicsmember" element={<UserLayout />}>
              <Route index element={<EthicsMember />} />
            </Route>
            <Route path="/ethicsboard" element={<UserLayout />}>
              <Route index element={<EthicsBoard />} />
            </Route>
            <Route path="/ethicsofficer" element={<UserLayout />}>
              <Route index element={<EthicsOfficer />} />
            </Route>
            <Route path="/depositservice" element={<UserLayout />}>
              <Route index element={<Depositservice />} />
            </Route>
            <Route path="/shareservice" element={<UserLayout />}>
              <Route index element={<Shareservice />} />
            </Route>
            <Route path="/manual" element={<UserLayout />}>
              <Route index element={<Manual />} />
            </Route>
            <Route path="/giftvoucher" element={<UserLayout />}>
              <Route index element={<Giftvoucher />} />
            </Route>
            <Route path="/bank" element={<UserLayout />}>
              <Route index element={<Bank />} />
            </Route>
            <Route path="/linktoother" element={<UserLayout />}>
              <Route index element={<Linktoother />} />
            </Route>
            <Route path="/regulation" element={<UserLayout />}>
              <Route index element={<Regulation />} />
            </Route>
            <Route path="/policy" element={<UserLayout />}>
              <Route index element={<Policy />} />
            </Route>
            <Route path="/enactment" element={<UserLayout />}>
              <Route index element={<Enactment />} />
            </Route>
            <Route path="/yearlyreport" element={<UserLayout />}>
              <Route index element={<Yearlyreport />} />
            </Route>
            <Route path="/calendar" element={<UserLayout />}>
              <Route index element={<Calendar />} />
            </Route>
            <Route path="/calculatedividend" element={<UserLayout />}>
              <Route index element={<Calculatedividend />} />
            </Route>
            <Route path="/withdrawatm" element={<UserLayout />}>
              <Route index element={<Withdrawatm />} />
            </Route>
            <Route path="/contactus" element={<UserLayout />}>
              <Route index element={<Contactus />} />
            </Route>
            <Route path="/personalloan" element={<UserLayout />}>
              <Route index element={<PersonalLoan />} />
            </Route>
            <Route path="/personalloanatm" element={<UserLayout />}>
              <Route index element={<PersonalLoanATM />} />
            </Route>
            <Route path="/personalloanfortop" element={<UserLayout />}>
              <Route index element={<PersonalLoanforTOP />} />
            </Route>
            <Route path="/personalloanformeremployee" element={<UserLayout />}>
              <Route index element={<PersonalLoanformerEmployee />} />
            </Route>
            <Route path="/personalloanforautomobiletop" element={<UserLayout />}>
              <Route index element={<PersonalLoanforAutomobileTOP />} />
            </Route>
            <Route path="/personalloanforhome" element={<UserLayout />}>
              <Route index element={<PersonalLoanforHome />} />
            </Route>
            <Route path="/personalloanforhomeplus" element={<UserLayout />}>
              <Route index element={<PersonalLoanforHomePlus />} />
            </Route>
            <Route path="/personalloanforrenovate" element={<UserLayout />}>
              <Route index element={<PersonalLoanforRenovate />} />
            </Route>
            <Route path="/personalloanforhomecondoredeem" element={<UserLayout />}>
              <Route index element={<PersonalLoanforHomeCondoRedeem />} />
            </Route>
            <Route path="/personalloanforredeem" element={<UserLayout />}>
              <Route index element={<PersonalLoanforRedeem />} />
            </Route>
            <Route path="/personalloanforhomeversatile" element={<UserLayout />}>
              <Route index element={<PersonalLoanforHomeVersatile />} />
            </Route>
            <Route path="/personalloanads/:id" element={<UserLayout />}>
              <Route index element={<Personalloanads />} />
            </Route>
            <Route path="/personalloanads" element={<UserLayout />}>
              <Route index element={<Personalloanads />} />
            </Route>
            <Route path="/anoucement" element={<UserLayout />}>
              <Route index element={<Anoucement />} />
            </Route>
            <Route path="/downloadform" element={<UserLayout />}>
              <Route index element={<Downloadform />} />
            </Route>
            <Route path="/activity" element={<UserLayout />}>
              <Route index element={<Activity />} />
            </Route>
            <Route path="/advertise" element={<UserLayout />}>
              <Route index element={<Advertise />} />
            </Route>
            <Route path="/activitydetail/:id" element={<UserLayout />}>
              <Route index element={<ActivityDetail />} />
            </Route>
            <Route path="/advertisedetail/:id" element={<UserLayout />}>
              <Route index element={<AdvertiseDetail />} />
            </Route>
            <Route path="/personalloandetail/:id" element={<UserLayout />}>
              <Route index element={<PersonalLoanDetail />} />
            </Route>

            {/* Catch-all route for redirecting unknown paths to /home */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Router>
      </div>
    );
  }
}